import { Typography, Tooltip } from "@mui/material";
import { CopyableTextProps } from "./utils/copyable.utils";
export const CopyableTextView = ({
  initialLabel,
  maxWidth = 180,
  state,
  theme,
  t,
  tooltipOnCopyOnly = false,
}: CopyableTextProps) => {
  const { isCopied, isHovered, setIsHovered, handleCopy } = state;

  let textColor;

  if (isCopied) {
    textColor = theme.palette.success.main;
  } else if (isHovered) {
    textColor = theme.palette.primary.main;
  } else {
    textColor = theme.palette.text.primary;
  }

  const text = (
    <Typography
      variant="body2"
      onClick={handleCopy}
      onMouseEnter={() => !isCopied && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        maxWidth,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: "pointer",
        transition: "0.2s",
        color: textColor,
        "&:hover": {
          textDecoration: "underline",
          opacity: 0.8,
        },
      }}
    >
      {initialLabel}
    </Typography>
  );

  // In this mode the tooltip only ever confirms the copy action — the raw
  // value is already visible as the text itself, so showing it again on
  // hover would be redundant.
  if (tooltipOnCopyOnly) {
    return (
      <Tooltip title={t("common.copied")} open={isCopied} arrow>
        {text}
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isCopied ? t("common.copied") : initialLabel} arrow>
      {text}
    </Tooltip>
  );
};
